export interface WorkspaceRouteLoadRequest {
  id: number
  path: string
}

export const createWorkspaceRouteLoadCoordinator = (
  getCurrentPath: () => string,
  replacePath: (path: string) => Promise<unknown>,
  fallbackPath = '/collections',
) => {
  let latestRequestId = 0
  let lastStablePath: string | null = null

  const begin = (): WorkspaceRouteLoadRequest => ({
    id: ++latestRequestId,
    path: getCurrentPath(),
  })

  const isCurrent = (request: WorkspaceRouteLoadRequest) =>
    request.id === latestRequestId && request.path === getCurrentPath()

  const markCurrentStable = (request?: WorkspaceRouteLoadRequest) => {
    if (request && !isCurrent(request)) return false
    lastStablePath = getCurrentPath()
    return true
  }

  const restoreAfterFailure = async (request: WorkspaceRouteLoadRequest) => {
    if (!isCurrent(request)) return false
    const restorePath =
      lastStablePath && lastStablePath !== request.path ? lastStablePath : fallbackPath
    if (restorePath === getCurrentPath()) return false
    await replacePath(restorePath)
    return true
  }

  return {
    begin,
    isCurrent,
    markCurrentStable,
    restoreAfterFailure,
  }
}
